export default __webpack_public_path__ + "10138ce6014da583ed4d593f11344a48.svg";